import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

const subCategoriesAdapter = createEntityAdapter({
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});

const initialState = subCategoriesAdapter.getInitialState();

export const subCategoriesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSubCategories: builder.query({
      query: () => "/subCategory",
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
      // transformResponse: (responseData) => {
      //   const loadedSubCategory = responseData.map((subCategory) => {
      //     subCategory.id = subCategory._id;
      //     return subCategory;
      //   });
      //   return subCategoriesAdapter.setAll(initialState, loadedSubCategory);
      // },
      providesTags: (result, error, arg) => {
        if (result?.ids) {
          return [
            { type: "SubCategory", id: "LIST" },
            ...result.ids.map((id) => ({ type: "SubCategory", id })),
          ];
        } else return [{ type: "SubCategory", id: "LIST" }];
      },
    }),
    createSubCategory: builder.mutation({
      query: data => ({
        url: "/subCategory/create",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [
        { type: "SubCategory", id: "LIST" }
      ]
    }),
    updateSubCategory: builder.mutation({
      query: data => ({
        url: "/subCategory/update",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "SubCategory", id: arg.id }
      ]
    }),
    deleteSubCategory: builder.mutation({
      query: ({ id }) => ({
          url: `/subCategory/delete`,
          method: "DELETE",
          body: { id }
      }),
      invalidatesTags: (result, error, arg) => [
          { type: "SubCategory", id: arg.id }
      ]
    }),
  }),
});

export const {
  useGetSubCategoriesQuery,
  useCreateSubCategoryMutation,
  useUpdateSubCategoryMutation,
  useDeleteSubCategoryMutation,
} = subCategoriesApiSlice

// returns the query result object
export const selectSubCategoriesResult = subCategoriesApiSlice.endpoints.getSubCategories.select()

// creates memoized selector
const selectSubCategoriesData = createSelector(
  selectSubCategoriesResult,
  subCategoriesResult => subCategoriesResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
  selectAll: selectAllSubCategories,
  selectById: selectSubCategoryById,
  selectIds: selectSubCategoryIds
  // Pass in a selector that returns the products slice of state
} = subCategoriesAdapter.getSelectors(state => selectSubCategoriesData(state) ?? initialState)
